"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _formik = require("formik");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FSelect = function FSelect(props) {
  var label = props.label,
      _props$form = props.form,
      dirty = _props$form.dirty,
      touched = _props$form.touched,
      errors = _props$form.errors,
      setFieldValue = _props$form.setFieldValue,
      _props$field = props.field,
      name = _props$field.name,
      value = _props$field.value,
      options = props.options,
      margin = props.margin,
      fullWidth = props.fullWidth,
      other = _objectWithoutProperties(props, ["label", "form", "field", "options", "margin", "fullWidth"]);

  var id = "sel_".concat(name);
  var errorText = (0, _formik.getIn)(errors, name);
  var touchedVal = (0, _formik.getIn)(touched, name);
  var hasError = dirty && touchedVal && errorText !== undefined;
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
    select: true,
    label: label,
    error: hasError,
    helperText: hasError ? errorText : '',
    onChange: function onChange(e) {
      return setFieldValue(name, e.target.value);
    },
    value: value,
    margin: margin,
    fullWidth: fullWidth
  }, other), options.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: "".concat(id, "_").concat(item.value),
      value: item.value
    }, item.label);
  }));
};

FSelect.propTypes = {
  label: _propTypes["default"].string.isRequired,
  field: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    onChange: _propTypes["default"].func,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  }).isRequired,
  form: _propTypes["default"].shape({
    dirty: _propTypes["default"].bool,
    errors: _propTypes["default"].object
  }).isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
  })).isRequired,
  fullWidth: _propTypes["default"].bool,
  margin: _propTypes["default"].oneOf(['none', 'dense', 'normal'])
};
FSelect.defaultProps = {
  fullWidth: true,
  margin: 'normal'
};
var _default = FSelect;
exports["default"] = _default;